import { provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { App } from './app/app';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/interceptors/auth-interceptor';

function initToken() {
  const token = new URLSearchParams(window.location.search).get('key');

  if (token) {
    localStorage.setItem('token', token);
  }
}

bootstrapApplication(App, {
  providers: [
    provideRouter(routes),
    provideAppInitializer(initToken),
    provideHttpClient(
      withInterceptors([authInterceptor])
    )
  ]
}).catch(err => console.error(err));
